import React from 'react'

import cn from 'classnames'
import s from './BarPage.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

import imgLogo from 'static/images/logo-white.png'

export default props => {
  const { children, title } = props
  return (
    <div className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'], sLay.flex, s.outer)}>
      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], s.bar)}>
        <div className={s.texture} />
        <div className={s.inner}>
          <img src={imgLogo} />
          {title && <div className={cn(sText.descrip2, s.title, sLay['hide-gt-xs'])}>{title}</div>}
        </div>
      </div>
      <div className={cn(s.content, sLay['layout-column'], sLay['layout-align-xs-center-center'])}>
        <div className={cn(s.contentInner, sLay['layout-column'], sLay['flex-gt-xs'])}>
          {children}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Layout/BarPage/BarPage.jsx